import { Injectable } from '@angular/core';
import { RemainingTime } from './types/remaining-time';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  static convertMaskToRegEx(mask): RegExp {
    // strip out {, }, -
    let pattern = mask.replace(/[{}-]/g, '');
    // replace arrays [a, b, c] with regex options (a|b|c)
    pattern = pattern.replace(/\[/g, '(').replace(/]/g, ')').replace(/,/g, '|');
    // replace 'X' wildcards with regex \d (for digit)
    pattern = pattern.replace(/X/g, '\\d');
    // match exact digits
    pattern = '\\b' + pattern + '\\b';
    // Make it a RegExp pattern
    return new RegExp(pattern);
  }

  static remainingTime(timestamp: number): RemainingTime {
    return {
      days: Math.floor(timestamp / 86400000),
      hours: Math.floor((timestamp % 86400000) / 3600000),
      minutes: Math.round(((timestamp % 86400000) % 3600000) / 60000),
      seconds: Math.round((((timestamp % 86400000) % 3600000) % 60000) / 1000),
    };
  }

  static removeTitleMenu() {
    const el = document.getElementsByTagName('lp2-title-bar').item(0);

    if (el) {
      el.classList.add('d-none');
    }
  }
  static isNotNull<T>(value: T): value is NonNullable<T> {
    return value != null;
  }

  // Object.entries() method
  static objectEntries(obj: any): [string, any][] {
    const ownProps = Object.keys( obj );
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  }

  static objectValues(obj: any): any[] {
    const ownProps = Object.keys( obj );
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = obj[ownProps[i]];
    }

    return resArray;
  }

  static createUrl(baseURL: string, params: Record<string, any> = {}) {
    return {
      get params() {
        return UtilsService.objectEntries(params)
          .map(([key, value]) => `${escape(key)}=${escape(value)}`)
          .join('&');
      },
      get href() {
        return `${baseURL}${this.params ? `?${this.params}` : ''}`;
      },
      setParams: (newParams: Record<string, any>) => {
        Object.assign(params, newParams);
      },
      setParam: (key: string, val: any) => {
        params[key] = val;
      },
      removeParam: (key: string) => {
        delete params[key];
      },
    };
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/utils.service.ts